module.exports = __webpack_public_path__ + "img/gta-v.89fc39d5.png";